export const WORKER_ID = 'workerId';
export const LONGITUDE = 'longitude';
export const LATITUDE = 'latitude';
export const CREATED_AT = 'createdAt';
export const BATTERY_LEVEL = 'batteryLevel';

